const lazyPrivacyPolicyPageComponent = () => import('@/Pages/En/PrivacyPolicy.vue');

export const privacyPolicyRoutes = [
  {
    path: '/privacy-policy',
    pathname: '/privacy-policy',
    name: 'privacy-policy',
    component: lazyPrivacyPolicyPageComponent,
    meta: {
      name: 'privacy-policy',
    },
  },
];
